import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as settingActions from "../../actions/settingActions";
import * as menteesRequestAction from "../../actions/menteesRequestAction";
import * as baseActions from "../../actions/baseActions";
import { Col, Dropdown } from "react-bootstrap";
import UserSidebar from "../../Component/UserSidebar";
import Details from "./details";
import Relationship from "./relationship";
import { getSubdomainPath, UCObjective, UCWords } from "../../utils/helpers";
import DToolkit from "./dtoolkit";
import Moment from "moment";
import FeedbackMentor from "./FeedbackMentor";
import ReportUser from "../Forum/reportUser";
import { Tooltip } from "@mui/material";
import config from "../../config";
import rainbow from '../../assets/images/rainbow.png'
import { imgPath } from "../../utils/imagePath";
import { getDatabase, ref, get, set } from "firebase/database";
import PropTypes from "prop-types";

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <button
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
    style={{ border: 'none', background: 'transparent', padding: 0 }}
  >
    {children}
    <span className="threedots" />
  </button>
));

CustomToggle.displayName = "CustomToggle";

CustomToggle.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
};

function SidebarAddClass(e) {
  e.preventDefault();
  document.getElementById("OnscrollBody").classList.toggle("show_sidebar");
}

function formatText(text) {
  return text?.split('\r\n')?.map((line, index) => (
    <React.Fragment key={line}>
      {line}
      <br />
    </React.Fragment>
  ));
}

const Index = (props) => {

  const { title, actions, menteeRequestData, userInfo, setting, steps_labels } = props;
  const [room, setRoom] = useState({ roomname: "" });
  const [userData] = useState({});
  const [endRelationship] = useState({});



  const isEmptyValue = (value) => {
    return (
      value === null ||
      value === undefined ||
      value === "" ||
      value === "null" ||
      value === "undefined" ||
      (Array.isArray(value) && value.length === 0)
    );
  };

  const getDynamicValue = (item, key) => {
    if (item?.reg_fields && Object.hasOwn(item.reg_fields, key)) {
      return item.reg_fields[key];
    }
    if (item?.reg_feilds && Object.hasOwn(item.reg_feilds, key)) {
      return item.reg_feilds[key];
    }
    return item?.[key];
  };

  const getRegFeildsOrderedKeys = (item) => {
    if (Array.isArray(item?.reg_feilds)) {
      return item.reg_feilds.flatMap((step) =>
        Array.isArray(step?.reg_feilds)
          ? step.reg_feilds.map((field) => field.reg_key)
          : []
      );
    }

    if (item?.reg_feilds && typeof item.reg_feilds === "object") {
      return Object.keys(item.reg_feilds);
    }

    return [];
  };

  const dynamicFieldReservedKeys = new Set([
    "image",
    "linkedin",
    "resume",
    "is_privacy",
    "first_name",
    "last_name",
    "full_name",
    "country_image_path",
    "reg_fields",
    "reg_feilds",
    "fields",
    "labels",
    "mentor_id",
    "mentee_id",
    "status",
    "mentor_name",
    "mentee_name",
    "mentee_image",
    "request_status",
    "mentor_mf_mental_health",
    "mentor_mf_certified_coach",
    "mentor_lgbtq_discussion",
    "mf_mental_health",
    "mf_certified_coach",
    "lgbtq_discussion",
    // "position",
    // "organization",
    // "domains"
  ]);

  const getKeysToUse = (item, orderedKeys) => {
    if (orderedKeys.length > 0) {
      return orderedKeys.filter(
        (key) => !dynamicFieldReservedKeys.has(key)
      );
    }

    if (item?.reg_fields && Object.keys(item.reg_fields).length > 0) {
      return Object.keys(item.reg_fields).filter(
        (key) => !dynamicFieldReservedKeys.has(key)
      );
    }

    return [
      "about",
      "restrictions_boundaries",
      "communication_tools",
      "frequency_communication",
      "any_particular_program",
      "topics",
      "board_entity_type",
      "objective",
      "experience_levels",
      "programmes",
      "gender",
      "number",
    ];
  };

  const getGroupName = (key, keyGroups) => {
    return Object.entries(keyGroups).find(
      ([, groupKeys]) => groupKeys.includes(key)
    )?.[0];
  };

  const getDynamicFieldKeys = (item) => {
    const orderedKeys = getRegFeildsOrderedKeys(item);

    const keysToUse = getKeysToUse(item, orderedKeys);

    const keyGroups = {
      about: ["about", "mentor_about"],
      restrictions_boundaries: ["restrictions_boundaries"],
      communication_tools: ["communication_tools"],
      frequency_communication: ["frequency_communication"],
      any_particular_program: [
        "any_particular_program",
        "any_particular_program_data",
      ],
      topics: ["topics"],
      board_entity_type: [
        "board_entity_type",
        "mentee_board_entity_type",
      ],
      objective: ["objective", "mentor_objective"],
      experience_levels: ["experience_levels"],
      programmes: ["programmes"],
      gender: ["gender"],
      number: ["number"],
      accredited_director: ["accredited_director"],
      course_completed: ["course_completed"],
      years_of_board_experience: [
        "years_of_board_experience",
      ],
      linkedin: ["linkedin", "mentor_linkedin"],
    };

    const seenGroups = new Set();
    const finalKeys = [];

    keysToUse.forEach((key) => {
      const groupName = getGroupName(key, keyGroups);

      if (groupName) {
        if (!seenGroups.has(groupName)) {
          seenGroups.add(groupName);
          finalKeys.push(groupName);
        }
        return;
      }

      if (!finalKeys.includes(key)) {
        finalKeys.push(key);
      }
    });

    return finalKeys;
  };

  const getDynamicFieldLabel = (item, key) => {
    const cleanLabel = steps_labels?.[key];

    if (cleanLabel) {
      const div = document.createElement("div");
      div.innerHTML = cleanLabel;

      return div.innerText
        .replaceAll("*", "")
        .trim();
    }

    return UCWords(key.replaceAll("_", " "));
  };

  const chipFields = new Set([
    "board_entity_type",
    "domains",
    "sub_domains",
    "objective",
    "experience_levels",
    "programmes",
    "course_completed",
    "accredited_director",
  ]);

  const textFields = new Set([
    "about",
    "topics",
    "communication_tools",
    "restrictions_boundaries",
    "frequency_communication",
  ]);

  const getDynamicItems = (value) => {
    if (!value) return [];

    if (Array.isArray(value)) {
      return value.map((v) =>
        typeof v === "object"
          ? v.title || v.name || v.label || ""
          : v
      );
    }

    if (typeof value === "string") {
      return value
        .split(/,|\|\|/)
        .map((v) => v.trim())
        .filter(Boolean);
    }

    return [];
  };

  const renderDynamicField = (item, key) => {
    let value = getDynamicValue(item, key);

    // grouped dynamic mappings
    if (key === "about") {
      value = item?.reg_fields?.about || item?.about;
    }
    if (key === "domains") {
      value = UCObjective(item?.reg_fields?.domains)
    }
    if (key === "past_board_roles") {
      value = UCObjective(item?.reg_fields?.past_board_roles)
    }
    if (key === "objective") {
      value = item?.reg_fields?.objective || item?.objective;
    }
    if (key === "board_entity_type") {
      value =
        item?.mentee_board_entity_type ||
        item?.reg_fields?.board_entity_type;
    }

    if (isEmptyValue(value)) return null;

    // PAST BOARD ROLES
    if (key === "past_board_roles") {
      const rawRoles = item?.reg_fields?.past_board_roles ?? item?.past_board_roles ?? value;
      let pastBoardRoles = [];
      if (Array.isArray(rawRoles)) {
        pastBoardRoles = rawRoles;
      } else if (typeof rawRoles === "string") {
        if (rawRoles.includes("||")) {
          pastBoardRoles = rawRoles.split("||").map((v) => v.trim()).filter(Boolean);
        } else if (rawRoles.trim()) {
          pastBoardRoles = [rawRoles.trim()];
        }
      }

      if (pastBoardRoles.length === 0) return null;

      const label = getDynamicFieldLabel(item, key);

      return (
        <div key={key}>
          <h3 className="mb-1">
            {label == "Past Board Roles" ? "Current / Past Board Roles" : label}
          </h3>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px", marginBottom: "10px" }}>
            {pastBoardRoles.map((role, idx) => {
              const text = typeof role === "object"
                ? `${role.rep_company_name ? role.rep_company_name + " – " : ""}${role.rep_board_title || ""}`
                : role;
              return (
                <li key={idx} style={{ listStyleType: "disc", marginBottom: "4px", fontSize: "14px" }}>
                  {text}
                </li>
              );
            })}
          </ul>
        </div>
      );
    }

    // ABOUT/TEXT BLOCKS
    if (textFields.has(key)) {
      return (
        <div className="mentro_text" key={key}>
          <h3 className="mb-1">
            {getDynamicFieldLabel(item, key)}
          </h3>

          <div className="about-text">
            <p>{formatText(value)}</p>
          </div>
        </div>
      );
    }

    // CHIP/TAG STYLE FIELDS
    if (chipFields.has(key)) {
      const items = getDynamicItems(value);

      if (items.length === 0) return null;

      return (
        <div className="mentro_text" key={key}>
          <h3 className="mb-1">
            {getDynamicFieldLabel(item, key)}
          </h3>

          <ul>
            {items.map((val, idx) => (
              <li key={val.id}>{val}</li>
            ))}
          </ul>
        </div>
      );
    }

    // DEFAULT UI
    return (
      <div className="mentro_text" key={key}>
        <h3 className="mb-1">
          {getDynamicFieldLabel(item, key)}
        </h3>

        <ul>
          <li>{typeof value === "object"
            ? JSON.stringify(value)
            : String(value)}</li>
        </ul>
      </div>
    );
  };

  const [modalShow, setModalShow] = useState(false);
  const [relationModalShow, setRelationModalShow] = useState(false);
  const location = useLocation();
  const history = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const request = {};
    if (params.get("sort")) {
      const sort = params.get("sort");
      const direction = params.get("direction");
      request.sort = sort;
      request.direction = direction;
    }
    if (params.get("page")) {
      const page = params.get("page");
      request.page = page;
    }
    if (params.get("keyword")) {
      const keyword = params.get("keyword");
      request.keyword = keyword;
    }
    document.title = title;
    actions.pendingRegMentorsRequest(request, 4);
  }, [title, actions, location, userInfo]);

  const [toolkitModalShow, setToolkitModalShow] = useState(false);

  // Helper to safely extract values and avoid undefined
  const safeValue = (value) => {
    return (value === undefined || value === null) ? "" : value;
  };

  useEffect(() => {
    if (room.roomname) {
      history("/chat?roomKey=" + room.roomname);
    }
  }, [room, history]);

  const handleClickChat = async (item) => {
    // --- Generate deterministic room key
    const roomUser =
      item.mentor_id > item.mentee_id
        ? `${item.mentor_id}_${item.mentee_id}`
        : `${item.mentee_id}_${item.mentor_id}`;

    const time = Moment.utc().valueOf();

    // --- Resolve mentor image from available fields
    const mentorImage = item.reg_fields?.image || item.mentors_image || item.mentor_image || "";

    // --- Construct the initial message object with sanitized values
    const message = {
      mentor_name: safeValue(item.mentor_name),
      mentor_image: safeValue(mentorImage),
      mentor_id: safeValue(item.mentor_id),
      mentee_name: safeValue(`${userInfo?.first_name} ${userInfo?.last_name}`),
      mentee_image: safeValue(userInfo?.image),
      mentee_id: safeValue(userInfo?.id),
      role_id: safeValue(userInfo?.role_id),
      device_type: "Web",
      message: "",
      key: safeValue(roomUser),
      status: 0,
      time: Moment(new Date()).format("DD/MM/YYYY HH:mm:ss"),
      epoch: -1 * time,
    };

    // --- Update React state safely
    setRoom((prev) => ({ ...prev, roomname: roomUser }));

    // --- Get Firebase database reference
    const db = getDatabase();

    // --- Define database paths
    const mentorDatabaseKey = `users/${item.mentor_id}/${roomUser}`;
    const menteeDatabaseKey = `users/${item.mentee_id}/${roomUser}`;

    try {
      // --- Check if mentor's chat record exists
      const mentorSnapshot = await get(ref(db, mentorDatabaseKey));
      if (!mentorSnapshot.exists()) {
        await set(ref(db, mentorDatabaseKey), message);
      }

      // --- Check if mentee's chat record exists
      const menteeSnapshot = await get(ref(db, menteeDatabaseKey));
      if (!menteeSnapshot.exists()) {
        await set(ref(db, menteeDatabaseKey), message);
      }
    } catch (error) {
      console.error(" Error creating chat room:", error);
    }
  };

  const [modelData] = useState("");
  const [model, setModel] = useState(false);
  const [userData2, setUserData2] = useState({});
  const [reportModalShow, setReportModalShow] = useState(false);

  const viewReportModal = (e, item) => {
    e.preventDefault();
    setReportModalShow(true);
    setUserData2({ item: item, from: "user" });
  };

  const getFieldValueAndStatus = (field) => {
    return setting?.mentor_fields_json?.find(item => item.field === field)?.value === "Yes";
  };

  const subDomainPath = getSubdomainPath();

  const downloadResume = (e, url) => {
    e.preventDefault();
    window.open(url, "_blank");
  };

  return (
    <div>
      <div className="dashboard_outer">
        <UserSidebar />
        <div className="dashboard_inner">
          <div className="d-block mb-3 mb-md-0 mb-md-none toggle_btn_outer">
            <Link
              to=""
              onClick={SidebarAddClass}
              className="toggle_btn d-lg-none"
            >
              <i className="fas fa-bars"></i>
            </Link>
          </div>
          <h1 className="dash_heading">Pending Mentor Requests</h1>
          <div className="box_wrap shadow-sm bg-white mentor_box">
            {menteeRequestData.map((item) => (
              <div className="mentro_details mb-2 mb-md-4 d-flex  flex-wrap" key={item.mentor_id}>
                <div className="mentro_details_leftbar">
                  <div className="mentor_pic">
                    <img
                      src={
                        item?.reg_fields?.image ||
                        item?.mentors_image ||
                        item?.mentee_image ||
                        imgPath + "mentor_women_two.png"
                      }
                      alt="find a career mentor online"
                    />
                  </div>
                  {getFieldValueAndStatus("linkedin") &&
                    (item?.reg_fields?.linkedin) && (
                      <div className="profile_btn mt-3 w-100">
                        <a
                          href={
                            item?.reg_fields?.linkedin
                          }
                          className="link_btn btn btn_red m-0 w-100"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={"/assets/images/linkedin.png"}
                            className="me-2 bg-white"
                            alt="career mentoring services"
                          />{" "}
                          Linkedin Profile
                        </a>
                      </div>
                    )}
                  <div className="extar_info_link">
                    <ul className="px-0 pt-2 mentor_log">
                      {subDomainPath !== 'siddev' && (
                        <li>
                          {getFieldValueAndStatus('mf_mental_health') && Number(item?.mentor_mf_mental_health) === 1 && (
                            <Tooltip
                              size="4xl"
                              title={
                                <h5>{config?.mf_mental_health}</h5>
                              }
                              describeChild
                              arrow
                            >
                              <img alt=""
                                src={
                                  imgPath +
                                  "usermind.svg"
                                }
                              />
                            </Tooltip>
                          )}
                        </li>
                      )}
                      {subDomainPath !== 'siddev' && (
                        <li>
                          {getFieldValueAndStatus('mf_certified_coach') && Number(item?.mentor_mf_certified_coach) === 1 && (
                            <Tooltip
                              size="4xl"
                              title={
                                <h5>{config?.mf_certified_coach}</h5>
                              }
                              describeChild
                              arrow
                            >
                              <img alt=""
                                src={
                                  imgPath +
                                  "useraward.svg"
                                }
                              />
                            </Tooltip>
                          )}
                        </li>
                      )}
                      {subDomainPath !== 'siddev' &&
                        getFieldValueAndStatus('lgbtq_discussion') && Number(item.mentor_lgbtq_discussion) === 1 && <li>
                          <Tooltip
                            size="4xl"
                            title={
                              <h5>{config?.LGBTQ_discussion}</h5>
                            }
                            describeChild
                            arrow
                          >
                            <img alt="" src={rainbow} />
                          </Tooltip>
                        </li>
                      }
                    </ul>
                  </div>
                </div>
                <div className="mentro_details_sidebar">
                  <div className="row py-2 py-md-4">
                    <Col xl={4}>
                      <div className="d-flex ">
                        <div className="name_info">
                          {(item?.reg_fields?.first_name ||
                            item?.reg_fields?.last_name ||
                            item?.mentor_name) && (
                              <h4 className="mb-0">
                                {`${item?.reg_fields?.first_name || ""} ${item?.reg_fields?.last_name || ""}`.trim() ||
                                  item?.mentor_name}
                              </h4>
                            )}

                          {/* {item?.reg_fields?.organization && (
                              <h5>
                                <span className="d-block">
                                  {item?.reg_fields?.organization}
                                </span>
                              </h5>
                            )}

                            {item?.reg_fields?.position && (
                              <h5>{item?.reg_fields?.position}</h5>
                            )}

                            {item?.reg_fields?.domains && (
                              <h5>
                                {UCWords(
                                  item?.reg_fields?.domains?.replaceAll("||", ", ")
                                )}
                              </h5>
                            )} */}
                        </div>
                      </div>
                    </Col>
                    <Col xl={8} className="">
                      <div className="current-mentees profile_btn d-flex justify-content-end align-items-center ">
                        <button
                          className="link_btn btn btn_red"
                          onClick={() => handleClickChat(item)}
                        >{" "}
                          <img
                            src="/assets/images/msg.png"
                            alt="msg_icon"
                            className="me-2 bg-white"
                          />{" "}
                          Send Message
                        </button>
                        <Dropdown>
                          <Dropdown.Toggle as={CustomToggle} />
                          <Dropdown.Menu
                            style={{ marginTop: "10px" }}
                            size="sm"
                            title=""
                          >
                            <Dropdown.Item
                              onClick={(e) => {
                                viewReportModal(e, item);
                              }}
                            >
                              Report
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </Col>
                  </div>
                  <ul className="mentorPending py-2 py-md-4">
                    <li className="d-flex align-items-start">
                      <div className="date_icon">
                        <img
                          src="/assets/images/calender.png"
                          alt="calender_image"
                        />
                      </div>
                      <div className="date_content ps-3">
                        <span className="d-block">
                          Request date
                        </span>
                        <span className="d-block date">
                          {item.session_start_date ? item.session_start_date : item.created_at}
                        </span>
                      </div>
                    </li>

                    <li className="d-flex align-items-center ml-5">
                      <div className="date_icon">
                        <img
                          src="/assets/images/flexible.png"
                          alt="calender_image"
                        />
                      </div>
                      <div className="date_content ps-3" style={{ marginTop: '-10px' }}>
                        <span className="d-block">
                          Pending request
                        </span>
                        <span className="d-block date" style={{ lineHeight: 0 }}>
                          {item.request_status}
                        </span>
                      </div>
                    </li>
                    {item?.reg_fields?.resume && (
                      <li className="d-flex align-items-center ml-5">
                        <div className="date_icon">
                          <img
                            src="/assets/images/pdf.png"
                            alt="resume_icon"
                          />
                        </div>

                        <div
                          className="date_content ps-3"
                          style={{ marginTop: "-10px" }}
                        >
                          <span className="d-block">
                            Resume
                          </span>

                          <Link
                            to=""
                            className="d-block date color_red"
                            onClick={(e) =>
                              downloadResume(
                                e,
                                item?.reg_fields?.resume
                              )
                            }
                          >
                            Download Resume
                          </Link>
                        </div>
                      </li>
                    )}
                  </ul>
                  {getDynamicFieldKeys(item).map((key) => renderDynamicField(item, key))}
                </div>
              </div>
            ))}
            {
              (menteeRequestData.length === 0) && (
                <div className="text-center">No pending mentor found.</div>
              )
            }
          </div >
        </div >
      </div >
      {
        modalShow && (
          <Details
            show={modalShow}
            userdata={userData}
            onHide={() => setModalShow(false)}
            centered
            size="xl"
            className="mentor_modal"
          />
        )
      }
      {
        model && (
          <FeedbackMentor
            show={model}
            userdata={modelData}
            onHide={() => setModel(false)}
            centered
            size="xl"
            className="mentor_modal"
          />
        )
      }
      {
        reportModalShow && (
          <ReportUser
            show={reportModalShow}
            userdata={userData2}
            onHide={() => setReportModalShow(false)}
            centered
            size="xl"
            className="mentor_modal"
          />
        )
      }
      {
        toolkitModalShow && (
          <DToolkit
            show={toolkitModalShow}
            onHide={() => setToolkitModalShow(false)}
            centered
            size="xl"
            className="mentor_modal"
          />
        )
      }
      {
        relationModalShow && (
          <Relationship
            show={relationModalShow}
            endrelationship={endRelationship}
            actions={actions}
            onHide={() => setRelationModalShow(false)}
            centered
            size="xl"
            className="mentor_modal"
          />
        )
      }
    </div >
  );
};

Index.propTypes = {
  title: PropTypes.string.isRequired,
  steps_labels: PropTypes.func.isRequired,
  actions: PropTypes.shape({
    pendingMentorsRequest: PropTypes.func.isRequired,
    pendingRegMentorsRequest: PropTypes.func.isRequired
  }).isRequired,
  menteeRequestData: PropTypes.arrayOf(PropTypes.shape({
    mentor_id: PropTypes.number,
    mentee_id: PropTypes.number,
    mentors_image: PropTypes.string,
    mentor_name: PropTypes.string,
    mentors_organization: PropTypes.string,
    mentors_position: PropTypes.string,
    mentor_main_area: PropTypes.string,
    mentor_linkedin: PropTypes.string,
    mentor_mf_mental_health: PropTypes.number,
    mentor_mf_certified_coach: PropTypes.number,
    request_status: PropTypes.string,
    created_at: PropTypes.string,
    length: PropTypes.number,
  })).isRequired,
  userInfo: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    role_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    image: PropTypes.string,
  }).isRequired,
  setting: PropTypes.shape({
    mentor_fields_json: PropTypes.arrayOf(PropTypes.shape({
      field: PropTypes.string,
      value: PropTypes.string,
    }).isRequired),
  }).isRequired,
};

function mapStateToProps(state) {
  return {
    menteeRequestData:
      state?.menteeRequestData?.data || [],
    steps_labels:
      state?.menteeRequestData
        ?.steps_labels || {},
    userInfo: state.userInfo,
    setting: state.setting,
    isAuth: state.isAuth,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...menteesRequestAction, ...baseActions, ...settingActions },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Index);
